module.exports = __webpack_public_path__ + "static/img/wdcs_qrcode.ea51264.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/provincial/wdcs_qrcode.svg
// module id = 225
// module chunks = 40